__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "players";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("i18next", "25.10.10", function() { return __webpack_require__.e(3917).then(function() { return function() { return __webpack_require__(6386); }; }); });
			register("next/dynamic", "14.2.16", function() { return Promise.all([__webpack_require__.e(5979), __webpack_require__.e(2261)]).then(function() { return function() { return __webpack_require__(2261); }; }); });
			register("next/head", "14.2.16", function() { return Promise.all([__webpack_require__.e(5979), __webpack_require__.e(9122)]).then(function() { return function() { return __webpack_require__(9122); }; }); });
			register("next/image", "14.2.16", function() { return Promise.all([__webpack_require__.e(4098), __webpack_require__.e(5979), __webpack_require__.e(817), __webpack_require__.e(769)]).then(function() { return function() { return __webpack_require__(4098); }; }); });
			register("next/link", "14.2.16", function() { return Promise.all([__webpack_require__.e(9176), __webpack_require__.e(5979), __webpack_require__.e(9227)]).then(function() { return function() { return __webpack_require__(3699); }; }); });
			register("next/router", "14.2.16", function() { return Promise.all([__webpack_require__.e(9176), __webpack_require__.e(1920), __webpack_require__.e(9433), __webpack_require__.e(5979), __webpack_require__.e(817), __webpack_require__.e(3817)]).then(function() { return function() { return __webpack_require__(9433); }; }); });
			register("next/script", "14.2.16", function() { return Promise.all([__webpack_require__.e(1920), __webpack_require__.e(5979), __webpack_require__.e(817), __webpack_require__.e(949)]).then(function() { return function() { return __webpack_require__(6357); }; }); });
			register("react-dom/client", "18.3.1", function() { return Promise.all([__webpack_require__.e(9774), __webpack_require__.e(817)]).then(function() { return function() { return __webpack_require__(8082); }; }); });
			register("react-dom", "18.3.1", function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(6321); }; }); });
			register("react-i18next", "15.7.4", function() { return __webpack_require__.e(7579).then(function() { return function() { return __webpack_require__(7579); }; }); });
			register("react/jsx-runtime", "18.13.1", function() { return function() { return __webpack_require__(1549); }; }, 1);
			register("react", "18.3.1", function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(4194); }; }); });
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(2998).then(function() { return function() { return __webpack_require__(2998); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(9043).then(function() { return function() { return __webpack_require__(9043); }; }); });
			initExternal(2219);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};